// Module
var code = "<div class=\"circle\"> <div class=\"circle-content\"><span class=\"circle-number\">2</span></div> </div>";
// Exports
module.exports = code;